import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { hideVisually } from 'polished';

export const Label = styled.label`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  -webkit-tap-highlight-color: transparent; /* disabled due to active state for switch */
  text-wrap: balance; /* if it has to wrap, at least wrap in style */
  cursor: pointer;
  user-select: none;
`;

type CheckProps = {
  $isChecked?: boolean;
};

export const Check = styled.span<CheckProps>`
  flex-shrink: 0;
  position: relative;
  padding: 1px;
  border: 1px solid;
  border-radius: 1.5rem;
  outline: 0;
  width: 2.625rem;
  height: 1.5rem;
  box-sizing: border-box;
  color: ${({ theme, $isChecked }) =>
    $isChecked ? theme.colors.brand.green120 : theme.colors.neutral.grey120};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  transition: border-color 0.2s ease;

  &::before {
    content: '';
    display: inline-block;
    border: 2px solid ${({ theme }) => theme.colors.neutral.white100};
    border-radius: 100%;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    background: currentcolor;
    transition: transform 0.2s ease;
    ${p =>
      p.$isChecked &&
      css`
        transform: translateX(100%) translateZ(0);
      `};
  }
`;

// screen reader only
export const Input = styled.input`
  ${hideVisually()};

  &:focus-visible + ${Check} {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;
